/*
 * AMAVI - Motor de resenas de coleccion
 * ---------------------------------------------------------------------------
 * Los bloques de resenas del tema estan hechos para leer UN archivo de UN
 * producto (assets/amavi-reviews-<sufijo>.json). En una coleccion hay que
 * mostrar las resenas de VARIOS productos.
 *
 * Estrategia elegida: mezcla en el navegador, sin generar ningun archivo
 * agregado. Cada seccion recibe en data-amavi-src la lista de archivos de los
 * productos de la coleccion, calculada en Liquid a partir del sufijo de
 * plantilla de cada producto. Los archivos por producto siguen siendo la unica
 * fuente de verdad: cuando se sustituyan las resenas de demostracion por las
 * reales, la coleccion se actualiza sola y no queda un segundo sitio que
 * mantener a mano.
 *
 * Azar sin sorpresas: la mezcla es un Fisher-Yates con generador sembrado
 * (mulberry32). Con la semilla del dia, la pagina ensena las mismas resenas
 * durante toda la jornada aunque se recargue, y rota al dia siguiente. Al
 * barajar sobre una lista ya deduplicada, es imposible que salga dos veces la
 * misma resena.
 */
(function () {
  'use strict';

  if (window.AmaviColReviews) return;

  var STAR_FULL =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 2l2.9 6.26 6.85.74-5.1 4.63 1.4 6.74L12 16.9 5.95 20.37l1.4-6.74-5.1-4.63 6.85-.74z"/></svg>';
  var STAR_EMPTY =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M12 3.5l2.47 5.33 5.83.63-4.34 3.94 1.19 5.74L12 16.2l-5.15 2.94 1.19-5.74-4.34-3.94 5.83-.63z"/></svg>';

  function starsHtml(n, cls) {
    var out = '';
    for (var i = 1; i <= 5; i++) {
      out += '<span class="' + cls + (i <= n ? '' : ' is-empty') + '">' + (i <= n ? STAR_FULL : STAR_EMPTY) + '</span>';
    }
    return out;
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null && text !== '') e.textContent = text;
    return e;
  }

  /* ---------------- azar reproducible ---------------- */

  function hashSeed(str) {
    var h = 2166136261 >>> 0;
    for (var i = 0; i < str.length; i++) {
      h ^= str.charCodeAt(i);
      h = Math.imul(h, 16777619) >>> 0;
    }
    return h >>> 0;
  }

  function mulberry32(a) {
    return function () {
      a |= 0;
      a = (a + 0x6d2b79f5) | 0;
      var t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  function shuffled(list, seedStr) {
    var rng = mulberry32(hashSeed(seedStr));
    var a = list.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(rng() * (i + 1));
      var t = a[i];
      a[i] = a[j];
      a[j] = t;
    }
    return a;
  }

  function seedFor(mode, base) {
    if (mode === 'fixed') return base;
    if (mode === 'session') {
      if (!window.__amaviColSession) window.__amaviColSession = String(Date.now()) + Math.random();
      return base + ' | ' + window.__amaviColSession;
    }
    var d = new Date();
    var day = '' + d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
    return base + ' | ' + day;
  }

  /* ---------------- carga y mezcla ---------------- */

  function keyOf(r) {
    return (r.nome || '') + ' :: ' + (r.data || '') + ' :: ' + (r.testo || '');
  }

  var poolCache = {};

  function loadPool(sources) {
    var cacheKey = sources
      .map(function (s) {
        return s.f;
      })
      .join(' | ');
    if (poolCache[cacheKey]) return poolCache[cacheKey];

    var p = Promise.all(
      sources.map(function (src) {
        return fetch(src.f, { credentials: 'omit' })
          .then(function (r) {
            if (!r.ok) throw new Error('http');
            return r.json();
          })
          .then(function (rows) {
            if (!Array.isArray(rows)) return [];
            return rows
              .filter(function (r) {
                return r && r.testo;
              })
              .map(function (r) {
                var stars = parseInt(r.stelle, 10);
                if (!(stars >= 1 && stars <= 5)) stars = 5;
                return {
                  stars: stars,
                  date: r.data || '',
                  name: String(r.nome || '').trim(),
                  verified: !!r.verificato,
                  text: String(r.testo).trim(),
                  reply: String(r.risposta || '').trim(),
                  photo: String(r.foto || '').trim(),
                  video: String(r.video || '').trim(),
                  product: src.p || '',
                  productUrl: src.u || '',
                  productImg: src.i || '',
                  key: keyOf(r)
                };
              });
          })
          .catch(function () {
            /* un archivo que falta no puede tumbar la seccion */
            return [];
          });
      })
    ).then(function (chunks) {
      var seen = {};
      var out = [];
      chunks.forEach(function (rows) {
        rows.forEach(function (r) {
          /* mismo texto repetido en dos productos: se guarda una sola vez */
          if (seen[r.key]) return;
          seen[r.key] = 1;
          out.push(r);
        });
      });
      return out;
    });

    poolCache[cacheKey] = p;
    return p;
  }

  function readSources(root) {
    try {
      var arr = JSON.parse(root.getAttribute('data-amavi-src') || '[]');
      return Array.isArray(arr)
        ? arr.filter(function (s) {
            return s && s.f;
          })
        : [];
    } catch (e) {
      return [];
    }
  }

  /* Registro compartido: lo que ya ha ensenado el carrusel, para que el
     listado de abajo no lo repita. */
  var pickedResolve = {};
  var pickedPromise = {};

  function pickedReady(scope) {
    if (!pickedPromise[scope]) {
      pickedPromise[scope] = new Promise(function (res) {
        pickedResolve[scope] = res;
      });
    }
    return pickedPromise[scope];
  }

  function publishPicked(scope, keys) {
    pickedReady(scope);
    pickedResolve[scope](keys);
  }

  function withTimeout(promise, ms, fallback) {
    return Promise.race([
      promise,
      new Promise(function (res) {
        setTimeout(function () {
          res(fallback);
        }, ms);
      })
    ]);
  }

  /* ---------------- carrusel ---------------- */

  function initCarousel(root) {
    if (root.dataset.amaviInit) return;
    root.dataset.amaviInit = '1';

    var d = root.dataset;
    var track = root.querySelector('[data-amavi-track]');
    var dotsBox = root.querySelector('[data-amavi-dots]');
    var empty = root.querySelector('[data-amavi-empty]');
    var scope = d.amaviScope || 'default';
    var want = parseInt(d.amaviCount, 10) || 6;
    var minStars = parseInt(d.amaviMinStars, 10) || 5;
    var minLen = parseInt(d.amaviMinLen, 10) || 60;
    var sources = readSources(root);

    if (!track || !sources.length) {
      if (empty) empty.hidden = false;
      publishPicked(scope, []);
      return;
    }

    loadPool(sources).then(function (pool) {
      if (!pool.length) {
        if (empty) empty.hidden = false;
        publishPicked(scope, []);
        return;
      }

      /* Escaparate: primero las que mejor lucen, y se afloja el filtro solo
         si no salen suficientes. Nunca se repite ninguna. */
      var tiers = [
        function (r) {
          return r.stars >= minStars && r.text.length >= minLen && r.name && !r.reply;
        },
        function (r) {
          return r.stars >= minStars && r.text.length >= minLen && !r.reply;
        },
        function (r) {
          return r.stars >= 4 && r.text.length >= 40;
        },
        function () {
          return true;
        }
      ];

      var order = shuffled(pool, seedFor(d.amaviRotation || 'daily', scope + ' | carrusel'));
      var chosen = [];
      var taken = {};

      tiers.forEach(function (test) {
        if (chosen.length >= want) return;
        order.forEach(function (r) {
          if (chosen.length >= want) return;
          if (taken[r.key]) return;
          if (!test(r)) return;
          taken[r.key] = 1;
          chosen.push(r);
        });
      });

      if (!chosen.length) {
        if (empty) empty.hidden = false;
        publishPicked(scope, []);
        return;
      }

      chosen.forEach(function (r, i) {
        track.appendChild(carouselCard(r, d, i));
      });

      if (dotsBox && chosen.length > 1) buildDots(track, dotsBox, d);

      publishPicked(
        scope,
        chosen.map(function (r) {
          return r.key;
        })
      );
    });
  }

  function carouselCard(r, d, index) {
    var card = el('article', 'amavi-colcar__card');
    card.setAttribute('data-amavi-card', String(index));

    var img = r.photo || r.productImg;
    var ring = el('div', 'amavi-colcar__ring');
    var frame = el('div', 'amavi-colcar__frame');
    if (img) {
      var im = document.createElement('img');
      im.src = img;
      im.alt = '';
      im.loading = 'lazy';
      im.decoding = 'async';
      im.className = 'amavi-colcar__img';
      frame.appendChild(im);
    } else {
      frame.classList.add('is-blank');
    }
    ring.appendChild(frame);

    if (r.productUrl) {
      var a = document.createElement('a');
      a.href = r.productUrl;
      a.className = 'amavi-colcar__link';
      a.setAttribute('aria-label', r.product || '');
      a.appendChild(ring);
      card.appendChild(a);
    } else {
      card.appendChild(ring);
    }

    var author = el('p', 'amavi-colcar__author');
    if (r.verified) {
      var v = el('span', 'amavi-colcar__check');
      v.setAttribute('aria-hidden', 'true');
      v.innerHTML =
        '<svg viewBox="0 0 16 16"><path d="M8 .8 9.9 2.1 12.2 2 13 4.2 14.9 5.5 14.3 7.7 15.2 9.8 13.4 11.3 13.2 13.6 10.9 14 9.4 15.8 8 14.9 6.6 15.8 5.1 14 2.8 13.6 2.6 11.3 .8 9.8 1.7 7.7 1.1 5.5 3 4.2 3.8 2 6.1 2.1 Z" fill="currentColor" opacity="0.15"/><path d="M5.2 8.1 7.1 10 10.9 5.9" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      author.appendChild(v);
    }
    author.appendChild(el('em', null, r.name || d.amaviAnon || ''));
    card.appendChild(author);

    var st = el('span', 'amavi-colcar__stars');
    st.setAttribute('role', 'img');
    st.setAttribute('aria-label', r.stars + ' / 5');
    st.innerHTML = starsHtml(r.stars, 'amavi-colcar__star');
    card.appendChild(st);

    if (d.amaviShowProduct === 'true' && r.product) {
      var h = el('h3', 'amavi-colcar__product');
      if (r.productUrl) {
        var pa = document.createElement('a');
        pa.href = r.productUrl;
        pa.textContent = r.product;
        h.appendChild(pa);
      } else {
        h.textContent = r.product;
      }
      card.appendChild(h);
    }

    card.appendChild(el('blockquote', 'amavi-colcar__quote', '«' + r.text + '»'));
    return card;
  }

  function buildDots(track, dotsBox, d) {
    var cards = track.querySelectorAll('[data-amavi-card]');
    var dots = [];
    cards.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'amavi-colcar__dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', (d.amaviDotLabel || '') + ' ' + (i + 1));
      b.addEventListener('click', function () {
        c.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
      dotsBox.appendChild(b);
      dots.push(b);
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            var idx = Array.prototype.indexOf.call(cards, e.target);
            dots.forEach(function (b, j) {
              b.classList.toggle('is-active', j === idx);
            });
          });
        },
        { root: track, threshold: 0.6 }
      );
      cards.forEach(function (c) {
        io.observe(c);
      });
    }
  }

  /* ---------------- listado con las diez al azar ---------------- */

  function initWidget(root) {
    if (root.dataset.amaviInit) return;
    root.dataset.amaviInit = '1';

    var d = root.dataset;
    var scope = d.amaviScope || 'default';
    var list = root.querySelector('[data-amavi-list]');
    var empty = root.querySelector('[data-amavi-empty]');
    var more = root.querySelector('[data-amavi-more]');
    var batch = parseInt(d.amaviCount, 10) || 10;
    var sources = readSources(root);

    if (!list || !sources.length) {
      if (empty) empty.hidden = false;
      return;
    }

    loadPool(sources).then(function (pool) {
      if (!pool.length) {
        if (empty) empty.hidden = false;
        return;
      }

      /* Media, total y barras se calculan sobre TODAS las resenas de la
         coleccion, no solo sobre las diez que se ensenan. */
      var total = pool.length;
      var sum = 0;
      var dist = { 1: 0, 2: 0, 3: 0, 4: 0, 5: 0 };
      pool.forEach(function (r) {
        sum += r.stars;
        dist[r.stars]++;
      });

      var avgNum = sum / total;
      var manual = parseInt(String(d.amaviTotal || '').replace(/\D/g, ''), 10);
      var showTot = manual > 0 ? manual : total;

      var avgStars = root.querySelector('[data-amavi-avgstars]');
      if (avgStars) avgStars.innerHTML = starsHtml(Math.round(avgNum), 'amavi-colrev__star');

      var avgEl = root.querySelector('[data-amavi-avg]');
      if (avgEl) avgEl.textContent = avgNum.toFixed(1).replace('.', ',') + (d.amaviOutof || '');

      var cntEl = root.querySelector('[data-amavi-count]');
      if (cntEl) cntEl.textContent = String(d.amaviSuffix || '').replace('{n}', showTot);

      var bars = root.querySelector('[data-amavi-bars]');
      if (bars) {
        for (var s = 5; s >= 1; s--) {
          var row = el('div', 'amavi-colrev__bar-row');
          var stx = el('span', 'amavi-colrev__bar-stars');
          stx.setAttribute('aria-hidden', 'true');
          stx.innerHTML = starsHtml(s, 'amavi-colrev__star amavi-colrev__star--sm');
          var trk = el('span', 'amavi-colrev__bar-track');
          var fill = el('span', 'amavi-colrev__bar-fill');
          fill.style.width = Math.round((dist[s] * 100) / total) + '%';
          trk.appendChild(fill);
          var n = manual > 0 ? Math.round((dist[s] * manual) / total) : dist[s];
          row.appendChild(stx);
          row.appendChild(trk);
          row.appendChild(el('span', 'amavi-colrev__bar-n', String(n)));
          bars.appendChild(row);
        }
      }

      var avoid = d.amaviAvoid === 'true' && !!document.querySelector('[data-amavi-colcar]');
      var ready = avoid ? withTimeout(pickedReady(scope), 2500, []) : Promise.resolve([]);

      ready.then(function (usedKeys) {
        var used = {};
        (usedKeys || []).forEach(function (k) {
          used[k] = 1;
        });

        var candidates = pool.filter(function (r) {
          return !used[r.key];
        });
        /* Si el carrusel se hubiera llevado casi todo, se vuelve al total. */
        if (candidates.length < batch) candidates = pool;

        var order = shuffled(candidates, seedFor(d.amaviRotation || 'daily', scope + ' | listado'));
        var shown = 0;

        function render() {
          var end = Math.min(shown + batch, order.length);
          for (; shown < end; shown++) list.appendChild(widgetCard(order[shown], d));
          if (more) more.hidden = shown >= order.length;
        }

        if (more) more.addEventListener('click', render);
        render();
      });
    });
  }

  function widgetCard(r, d) {
    var c = el('article', 'amavi-colrev__card');

    var top = el('div', 'amavi-colrev__top');
    var st = el('span', 'amavi-colrev__stars');
    st.setAttribute('aria-label', r.stars + ' / 5');
    st.innerHTML = starsHtml(r.stars, 'amavi-colrev__star');
    top.appendChild(st);
    if (r.date) top.appendChild(el('span', 'amavi-colrev__date', r.date));
    c.appendChild(top);

    var who = el('div', 'amavi-colrev__who');
    var av = el('span', 'amavi-colrev__avatar');
    av.setAttribute('aria-hidden', 'true');
    av.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="8" r="3.4"/><path d="M4.5 20c1.6-3.4 4.3-5 7.5-5s5.9 1.6 7.5 5"/></svg>';
    who.appendChild(av);
    who.appendChild(el('span', 'amavi-colrev__name', r.name || d.amaviAnon || ''));
    if (r.verified && d.amaviVerified) who.appendChild(el('span', 'amavi-colrev__verified', d.amaviVerified));
    c.appendChild(who);

    c.appendChild(el('p', 'amavi-colrev__text', r.text));

    /* De que producto es la resena: dentro de una coleccion es informacion util */
    if (d.amaviShowProduct === 'true' && r.product) {
      var pw = el('p', 'amavi-colrev__product');
      pw.appendChild(el('span', null, d.amaviProductPrefix || ''));
      if (r.productUrl) {
        var a = document.createElement('a');
        a.href = r.productUrl;
        a.textContent = r.product;
        pw.appendChild(a);
      } else {
        pw.appendChild(el('span', null, r.product));
      }
      c.appendChild(pw);
    }

    if (r.photo) {
      var mw = el('div', 'amavi-colrev__media');
      var im = document.createElement('img');
      im.src = r.photo;
      im.loading = 'lazy';
      im.decoding = 'async';
      im.alt = '';
      mw.appendChild(im);
      c.appendChild(mw);
    }

    if (r.video) {
      var vw = el('div', 'amavi-colrev__media');
      var vd = document.createElement('video');
      vd.src = r.video;
      vd.controls = true;
      vd.preload = 'none';
      vw.appendChild(vd);
      c.appendChild(vw);
    }

    if (r.reply) {
      var rp = el('div', 'amavi-colrev__reply');
      if (d.amaviReply) rp.appendChild(el('p', 'amavi-colrev__reply-label', d.amaviReply));
      rp.appendChild(el('p', 'amavi-colrev__reply-text', r.reply));
      c.appendChild(rp);
    }

    return c;
  }

  /* ---------------- arranque ---------------- */

  function boot(scope) {
    var s = scope && scope.querySelectorAll ? scope : document;
    s.querySelectorAll('[data-amavi-colcar]').forEach(initCarousel);
    s.querySelectorAll('[data-amavi-colrev]').forEach(initWidget);
  }

  window.AmaviColReviews = { boot: boot, loadPool: loadPool };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target || document);
  });
})();
